import {
  Component,
  OnInit,
  Inject,
  EventEmitter
} from '@angular/core';
import { CampusUnitMessage } from '../../../models/notifications/campus-unit-message.model';
import {
  StartDateBeforeEndDate,
  StartEndDateValidParentMatcher
} from '../../../validators/form.validator';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-campus-unit-message-edit-dialog',
  templateUrl: './campus-unit-message-edit-dialog.component.html',
  styleUrls: ['./campus-unit-message-edit-dialog.component.scss']
})
export class CampusUnitMessageEditDialogComponent implements OnInit {
  title = 'New Message';
  message = '';
  isNew = true;
  messageForm: FormGroup;
  startDatePos = new Date();
  endDatePos = new Date();
  minDate = new Date();
  isValidForm = false;
  currentMessage: CampusUnitMessage;
  startEndDateValidParentMatcher = new StartEndDateValidParentMatcher();

  onFinishedCreate = new EventEmitter<CampusUnitMessage>();
  onFinishedEdit = new EventEmitter<any>();

  startDateControl = new FormControl(new Date(), [Validators.required]);
  endDateControl = new FormControl(new Date(), [Validators.required]);
  messageControl = new FormControl('', [Validators.required]);

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<CampusUnitMessageEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.title = data ? 'Edit' : 'New Message';

    if (data && data.currentMessage) {
      this.currentMessage = data.currentMessage;
      this.messageControl.setValue(this.currentMessage.message);
      this.isNew = false;

      if (this.currentMessage.startDate) {
        this.startDatePos = new Date(this.currentMessage.startDate);
        this.startDateControl.setValue(this.startDatePos);
      }
      if (this.currentMessage.endDate) {
        this.endDatePos = new Date(this.currentMessage.endDate);
        this.endDateControl.setValue(this.endDatePos);
      }
    }
  }

  ngOnInit() {
    this.messageForm = this.formBuilder.group(
      {
        startDateControl: this.startDateControl,
        endDateControl: this.endDateControl,
        messageControl: this.messageControl
      },
      { validator: StartDateBeforeEndDate }
    );

    this.messageForm.valueChanges.subscribe(data => {
      this.validateForm();
    });
  }

  close() {
    this.dialogRef.close();
  }

  validForm() {
    return this.messageForm.valid;
  }

  isValidDateRange() {
    const startDate = new Date(this.startDateControl.value);
    const endDate = new Date(this.endDateControl.value);

    return endDate > startDate;
  }

  validateForm(): any {
    if (this.validForm()) {
      this.isValidForm = true;
    } else {
      this.isValidForm = false;
    }
  }

  save() {
    if (!this.validForm()) {
      this.isValidForm = false;
      return;
    }

    let newMessage: CampusUnitMessage = new CampusUnitMessage();
    this.isValidForm = true;
    if (!this.isNew) {
      newMessage = Object.assign(this.currentMessage);
    }

    newMessage.message = this.messageControl.value;
    newMessage.startDate = new Date(this.startDateControl.value);
    newMessage.endDate = new Date(this.endDateControl.value);
    newMessage.active = true;

    if (!this.isNew) {
      this.onFinishedEdit.emit({
        currentMessage: this.currentMessage,
        newMessage: newMessage
      });
    } else {
      this.onFinishedCreate.emit(newMessage);
    }

    // Incase the calling component is subscribing to the afterClose event
    this.dialogRef.close({
      currentMessage: this.currentMessage,
      newMessage: newMessage
    });
  }

  tinyMceInit = {
    height: 300,
    menubar: false,
    plugins: 'lists link preview wordcount visualblocks',
    toolbar:
      'insert | undo redo |  formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat',
  }
}
